'use client';

import { useTheme } from 'next-themes';
import type { CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--width': 'min(calc(100vw - 32px), 480px)',
        } as CSSProperties
      }
      toastOptions={{
        style: {
          background: 'hsl(var(--card))',
          color: 'hsl(var(--card-foreground))',
          border: '1px solid hsl(var(--border))',
          borderRadius: '9999px',
          boxShadow: 'none',
          width: 'max-content',
          maxWidth: 'min(calc(100vw - 32px), 480px)',
          overflowWrap: 'normal',
        },
        classNames: {
          toast:
            'group toast !w-max !max-w-[min(calc(100vw-32px),480px)] !rounded-full !border !border-border !bg-card !text-card-foreground !shadow-none data-[x-position=center]:!left-0 data-[x-position=center]:!right-0 data-[x-position=center]:!mx-auto',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
